import { ITemplate, TemplateType } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { BaseComponentModel } from 'src/app/common/component-model/base-component-model';
import { ComponentModelDependencies } from 'src/app/common/component-model/component-model-dependencies';
import { ComponentModelInfo } from 'src/app/common/component-model/component-model-info';
import { TemplateModelName } from 'src/app/shared/models/model-names';

@Injectable({ providedIn: 'root' })
export class TemplateComponentModel extends BaseComponentModel<ITemplate> {
  /**
   * ComponentModel for all template relevant actions and dependencies
   */
  constructor(componentModelDependencies: ComponentModelDependencies, componentModelInfo: ComponentModelInfo) {
    super(TemplateModelName, componentModelDependencies, componentModelInfo);
  }
}
